// Share Button Module
export function initializeShare() {
    createShareButton();
    createShareModal();
    setupShareEventListeners();
}

function createShareButton() {
    const shareBtn = document.createElement('button');
    shareBtn.className = 'share-btn';
    shareBtn.id = 'share-btn';
    shareBtn.innerHTML = `
        <i class="fa fa-share-alt"></i>
        <span class="share-text">Share</span>
    `;
    shareBtn.title = 'Share Garden Planner';
    
    document.body.appendChild(shareBtn);
}

function createShareModal() {
    const shareModal = document.createElement('div');
    shareModal.className = 'share-modal';
    shareModal.id = 'share-modal';
    shareModal.innerHTML = `
        <div class="share-modal-content">
            <button class="share-modal-close" id="share-modal-close">×</button>
            <h3>Share Garden Planner</h3>
            <p>Share this amazing garden planning tool with your friends and family!</p>
            <div class="share-buttons-grid">
                <a href="#" class="share-platform-btn share-facebook" id="share-facebook" target="_blank">
                    <i class="fa fa-facebook"></i>
                    <span>Facebook</span>
                </a>
                <a href="#" class="share-platform-btn share-twitter" id="share-twitter" target="_blank">
                    <i class="fa fa-twitter"></i>
                    <span>Twitter</span>
                </a>
                <a href="#" class="share-platform-btn share-whatsapp" id="share-whatsapp" target="_blank">
                    <i class="fa fa-whatsapp"></i>
                    <span>WhatsApp</span>
                </a>
                <a href="#" class="share-platform-btn share-pinterest" id="share-pinterest" target="_blank">
                    <i class="fa fa-pinterest"></i>
                    <span>Pinterest</span>
                </a>
                <a href="#" class="share-platform-btn share-linkedin" id="share-linkedin" target="_blank">
                    <i class="fa fa-linkedin"></i>
                    <span>LinkedIn</span>
                </a>
            </div>
        </div>
    `;
    
    document.body.appendChild(shareModal);
}

function setupShareEventListeners() {
    const shareBtn = document.getElementById('share-btn');
    const shareModal = document.getElementById('share-modal');
    const shareModalClose = document.getElementById('share-modal-close');
    
    // Open modal
    shareBtn.addEventListener('click', () => {
        shareModal.classList.add('show');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
    });
    
    // Close modal
    shareModalClose.addEventListener('click', () => {
        closeShareModal();
    });
    
    // Close modal when clicking outside
    shareModal.addEventListener('click', (e) => {
        if (e.target === shareModal) {
            closeShareModal();
        }
    });
    
    // Close modal with Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && shareModal.classList.contains('show')) {
            closeShareModal();
        }
    });
    
    // Setup platform sharing
    setupPlatformSharing();
}

function closeShareModal() {
    const shareModal = document.getElementById('share-modal');
    shareModal.classList.remove('show');
    document.body.style.overflow = ''; // Restore scrolling
}

function setupPlatformSharing() {
    const shareUrl = encodeURIComponent('https://app.flourishingplants.com/');
    const shareTitle = encodeURIComponent('Check out this amazing Garden Planner!');
    const shareDescription = encodeURIComponent('Plan your perfect garden with this interactive tool. Design layouts, get companion planting suggestions, and track your garden progress!');
    const shareImage = encodeURIComponent('https://app.flourishingplants.com/assets/Garden-Layouts.webp');
    
    // Facebook
    const facebookBtn = document.getElementById('share-facebook');
    facebookBtn.href = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
    
    // Twitter
    const twitterBtn = document.getElementById('share-twitter');
    twitterBtn.href = `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`;
    
    // WhatsApp
    const whatsappBtn = document.getElementById('share-whatsapp');
    whatsappBtn.href = `https://wa.me/?text=${shareTitle}%20${shareUrl}`;
    
    // Pinterest
    const pinterestBtn = document.getElementById('share-pinterest');
    pinterestBtn.href = `https://pinterest.com/pin/create/button/?url=${shareUrl}&description=${shareDescription}&media=${shareImage}`;
    
    // LinkedIn
    const linkedinBtn = document.getElementById('share-linkedin');
    linkedinBtn.href = `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`;
    
    // Add click tracking (optional)
    [facebookBtn, twitterBtn, whatsappBtn, pinterestBtn, linkedinBtn].forEach(btn => {
        btn.addEventListener('click', (e) => {
            const platform = btn.id.replace('share-', '');
            console.log(`Sharing to ${platform}: ${decodeURIComponent(shareUrl)}`);
            
            // Close modal after short delay
            setTimeout(() => {
                closeShareModal();
            }, 500);
        });
    });
} 